// Detect if the device is a mobile PHONE (personal device).
// iPads, tablets, laptops, desktops are treated as shared hospital devices.
// Owner/solution roles always persist auth regardless of device.

export function isMobilePhone() {
  var ua = navigator.userAgent || '';
  // iPhone, Android phone (has "Mobile" in UA), Windows Phone
  if (/iPhone|Windows Phone/i.test(ua)) return true;
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true;
  // Everything else: iPad, Android tablet, laptop, desktop → shared device
  return false;
}

// Should auth be persisted to localStorage?
// YES for: owner/solution (any device), remote-access users on mobile, or any mobile phone user
// NO for: on-site staff on shared devices (iPad, laptop, desktop)
export function shouldPersistAuth(roles, authObj) {
  var r = roles || [];
  if (r.indexOf('owner') !== -1 || r.indexOf('solution') !== -1) return true;
  // Saadhak (patient) always persists — they use personal phones
  if (r.indexOf('saadhak') !== -1 || r.indexOf('saadhakdashboard') !== -1) return true;
  // Users with full remote access persist on any device
  if (authObj && (authObj.allowedOutside || authObj.limitedRemoteAccess)) return true;
  return isMobilePhone();
}
